export default String.raw`
.card-product {
    height: 406px;

    &__image {
        height: 186px;
    }

    &__buttons {
        .button__text {
            display: none;
        }
    }
}
`